import { getClientReferenceId } from "./amplitude";
import { getUtmMetadataFromSearch } from "./utm";

const storageKey = "owned_email_checkout_v1";
const uuid = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/;
const emailUtmKeys = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
const clear = () => { try { sessionStorage.removeItem(storageKey); } catch (_) {} };

// Attribution is tab-local and session-bound, never authentication.
export function getEmailAttributionMetadata(search = window.location.search) {
  const params = new URLSearchParams(search || "");
  const reference = params.has("client_reference_id") ? params.get("client_reference_id") : getClientReferenceId();
  if (!/^[1-9][0-9]{0,18}$/.test(reference || "")) { clear(); return {}; }
  const source = params.get("utm_source");
  if (source && source !== "email") { clear(); return {}; }
  if (params.has("email_message_ref")) {
    const ref = params.get("email_message_ref");
    if (!uuid.test(ref || "")) { clear(); return {}; }
    const utm = Object.fromEntries(emailUtmKeys.filter(k => params.get(k)).map(k => [k, params.get(k).slice(0, 128)]));
    const metadata = { ...utm, email_message_ref: ref };
    try { sessionStorage.setItem(storageKey, JSON.stringify({ reference, metadata, createdAt: Date.now() })); } catch (_) {}
    return metadata;
  }
  try {
    const saved = JSON.parse(sessionStorage.getItem(storageKey) || "null");
    if (saved && saved.reference === reference && Number.isFinite(saved.createdAt) &&
      Date.now() >= saved.createdAt && Date.now() - saved.createdAt < 86400000 &&
      uuid.test(saved.metadata?.email_message_ref || "")) {
      // Re-whitelist storage too; malformed/custom entries are not spread into checkout.
      const utm = Object.fromEntries(emailUtmKeys.filter(k => typeof saved.metadata[k] === "string").map(k => [k, saved.metadata[k].slice(0, 128)]));
      return { ...utm, email_message_ref: saved.metadata.email_message_ref };
    }
  } catch (_) {}
  clear();
  return {};
}

export function getCheckoutMetadataFromSearch(search, options = {}) {
  return { ...getEmailAttributionMetadata(search), ...getUtmMetadataFromSearch(search, options) };
}
